<template>
  <div class="home">
  <video id="homeVideo" class="video" controls autoplay muted loop>
  <source src= "../assets/video.mp4" type="video/mp4"></video>
 
   <div  id="image">
     <div class="blah" id="preloader" >
<div class="lds-css">
<div class="lds-microsoft">
<div></div>
<div></div>
<div></div>
<div></div>
<div></div>
<div></div>
<div></div>
<div></div>
</div>
</div>
</div>
    </div> 
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data () {
    return {
  
    }
  },
  mounted(){
      this.$store.commit("TOP_BAR_IS_HIDEN")
      this.$store.commit("HIDE_ALLERT");
     
      var video = document.getElementById("homeVideo");
      video.oncanplaythrough = function() {
        var elem = document.getElementById("image");
        elem.style.display = "none";
      
      }
  },
  computed:{
     ...mapGetters(["topBarIsShown"]),
  }

}
</script>
<style  scoped lang="scss">
.blah {
  position: absolute;
  top:33%;
  left:40%;
  width: 180px;
  height: 120px;
  margin: -25px 0 25px;
  flex: 1 1 180px;
  transform: scale(1);
}

.lds-css {
    width: 200px;
    height:200px;
    margin:auto;
    transform: scale(0.5)
    }
	
@-webkit-keyframes lds-microsoft {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
    
  }
}

@keyframes lds-microsoft {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
    
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
    
  
  }
}

.lds-microsoft {
  position: relative;
}

.lds-microsoft div {
  position: absolute;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  -webkit-animation: lds-microsoft 1.5s cubic-bezier(.2,.64,.81,.23) infinite;
  animation: lds-microsoft 1.5s cubic-bezier(.2,.64,.81,.23) infinite;
}

.lds-microsoft div:nth-child(0) {
  background: darkgoldenrod;;
  top: 134.613px;
  left: 147.535px;
  -webkit-transform-origin: -47.535px -34.613px;
  transform-origin: -47.535px -34.613px;
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}

.lds-microsoft div:nth-child(1) {
  background: darkgoldenrod;;
  top: 147.535px;
  left: 134.613px;
  -webkit-transform-origin: -34.613px -47.535px;
  transform-origin: -34.613px -47.535px;
  -webkit-animation-delay: -0.062s;
  animation-delay: -0.062s;
}

.lds-microsoft div:nth-child(2) {
  background: darkgoldenrod;;
  top: 156.672px;
  left: 118.788px;
  -webkit-transform-origin: -18.788px -56.672px;
  transform-origin: -18.788px -56.672px;
  -webkit-animation-delay: -0.125s;
  animation-delay: -0.125s;
}

.lds-microsoft div:nth-child(3) {
  background: darkgoldenrod;;
  top: 161.401px;
  left: 101.137px;
  -webkit-transform-origin: -1.137px -61.401px;
  transform-origin: -1.137px -61.401px;
  -webkit-animation-delay: -0.187s;
  animation-delay: -0.187s;
}

.lds-microsoft div:nth-child(4) {
  background: darkgoldenrod;;
  top: 161.401px;
  left: 82.863px;
  -webkit-transform-origin: 17.137px -61.401px;
  transform-origin: 17.137px -61.401px;
  -webkit-animation-delay: -0.25s;
  animation-delay: -0.25s;
}

.lds-microsoft div:nth-child(5) {
  background: darkgoldenrod;;
  top: 156.672px;
  left: 65.212px;
  -webkit-transform-origin: 34.788px -56.672px;
  transform-origin: 34.788px -56.672px;
  -webkit-animation-delay: -0.312s;
  animation-delay: -0.312s;
}

.lds-microsoft div:nth-child(6) {
  background: darkgoldenrod;;
  top: 147.535px;
  left: 49.387px;
  -webkit-transform-origin: 50.613px -47.535px;
  transform-origin: 50.613px -47.535px;
  -webkit-animation-delay: -0.375s;
  animation-delay: -0.375s;
}

.lds-microsoft div:nth-child(7) {
  background: darkgoldenrod;;
  top: 134.613px;
  left: 36.465px;
  -webkit-transform-origin: 63.535px -34.613px;
  transform-origin: 63.535px -34.613px;
  -webkit-animation-delay: -0.437s;
  animation-delay: -0.437s;
}
@keyframes blink {
  
    0% {
      opacity: .2;
    }
   
    20% {
      opacity: 1;
    }
   
    100% {
      opacity: .2;
    }
}



// #loading{
//    position:absolute;
//    background: url("../image/Loading icon.png") no-repeat;
  
//    bottom: 55%;
//    left:45%;
//    width: 15%;
//    height: 20%;
// }
// .loading  {
  
//     animation-name: blink;
   
//     animation-duration: 1.4s;
    
//     animation-iteration-count: infinite;
   
//     animation-fill-mode: both;
// }



#image{
  background: url("../image/bg.jpg") no-repeat;
  position:absolute;
  // z-index: 2000;
  width:100%;
 height: 100%;
 margin: auto;

}
.home {
  display: flex;
  justify-content: center;
}
.video {
  width: 100%;
}

</style>

